import React from 'react';
import { Chip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import PendingIcon from '@mui/icons-material/Pending';
import ErrorIcon from '@mui/icons-material/Error';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const KycStatusBadge = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'verified':
        return {
          label: 'Verified',
          color: 'success',
          icon: <VerifiedIcon fontSize="small" />,
        };
      case 'pending':
        return {
          label: 'Pending',
          color: 'warning',
          icon: <PendingIcon fontSize="small" />,
        };
      case 'rejected':
        return {
          label: 'Rejected',
          color: 'error',
          icon: <ErrorIcon fontSize="small" />,
        };
      case 'not_submitted':
      default:
        return {
          label: 'Not Submitted',
          color: 'default',
          icon: <HelpOutlineIcon fontSize="small" />,
        };
    }
  };

  const { label, color, icon } = getStatusConfig();

  return (
    <Chip
      icon={icon}
      label={label}
      color={color}
      size="small"
      variant="outlined"
      sx={{ fontWeight: 500 }}
    />
  );
};

export default KycStatusBadge;
